import { render, staticRenderFns } from "./Create-Vendor.vue?vue&type=template&id=6a18df46"
import script from "./Create-Vendor.vue?vue&type=script&lang=js"
export * from "./Create-Vendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports